import type { ExportingMimeTypeValue, ExportingOptions, Options } from 'highcharts';
import type Highcharts from 'highcharts/highstock';

declare module 'highcharts' {
  interface Chart {
    exportChart: (options: ExportingOptions, chartOptions?: Options) => void;
  }
}

type ExportChartImageParams = {
  chart: Highcharts.Chart;
  type: ExportingMimeTypeValue;
  filename: string;
  options: Highcharts.Options;
  exportingOptions?: Omit<Highcharts.ExportingOptions, 'type' | 'filename'>;
};

export const exportChartImage = ({
  chart,
  type,
  filename,
  options,
  exportingOptions
}: ExportChartImageParams) => {
  chart.exportChart({ type, filename, ...exportingOptions }, options);
};
